import script from "./Register1.vue?vue&type=script&setup=true&lang=ts"
export * from "./Register1.vue?vue&type=script&setup=true&lang=ts"

import "./Register1.vue?vue&type=style&index=0&id=7ec5b28b&lang=less&scoped=true"

import exportComponent from "D:\\Code\\BranchManageSystem\\UI\\risfond-branchmanagementsystem\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-7ec5b28b"]])

export default __exports__